
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/affiliate-marketing",
      function () {
        return require("private-next-pages/platform/affiliate-marketing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/affiliate-marketing"])
      });
    }
  